import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

export const styleCondition = (styleProp, defaultValue, dim) => {
  return styleProp ? `${styleProp}${dim}` : `${defaultValue}${dim}`;
};

export const dirCondition = (
  className,
  dir = getDir(getCurrentLangFromRedux())
) => (dir == "ltr" ? className + "EN" : className + "AR");
